module.exports = __webpack_public_path__ + "static/img/vrroad_function03.9103551e.png";